import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './SidebarMenu.css';

const SidebarMenu = () => {
  const [expanded, setExpanded] = useState({});

  const toggleSection = (section) => {
    setExpanded((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <nav className="admin-sidebar-nav">
      <NavLink to="/admin" end className="nav-link">
        Dashboard
      </NavLink>

      {/* Academics */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('academics')}>
          <span>Academics</span>
          <span className="nav-arrow">{expanded.academics ? '▼' : '▶'}</span>
        </div>
        {expanded.academics && (
          <div className="nav-submenu">
            <NavLink to="/admin/academics/faculty-information" className="nav-sublink">
              Faculty Information
            </NavLink>
            {/* <NavLink to="/admin/academics/academic-calendar" className="nav-sublink">
              Academic Calendar
            </NavLink> */}
          </div>
        )}
      </div>

      {/* Admissions */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('admissions')}>
          <span>Admissions</span>
          <span className="nav-arrow">{expanded.admissions ? '▼' : '▶'}</span>
        </div>
        {expanded.admissions && (
          <div className="nav-submenu">
            <NavLink to="/admin/admissions/faqs" className="nav-sublink">
              FAQ's (Admission and General)
            </NavLink>
          </div>
        )}
      </div>

      {/* Placement */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('placement')}>
          <span>Placement</span>
          <span className="nav-arrow">{expanded.placement ? '▼' : '▶'}</span>
        </div>
        {expanded.placement && (
          <div className="nav-submenu">
            <NavLink to="/admin/placement/top-recruiters" className="nav-sublink">
              Top Recruiters
            </NavLink>
            <NavLink to="/admin/placement/placed-students" className="nav-sublink">
              Placed Students
            </NavLink>
          </div>
        )}
      </div>

      {/* Examinations */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('examinations')}>
          <span>Examinations</span>
          <span className="nav-arrow">{expanded.examinations ? '▼' : '▶'}</span>
        </div>
        {expanded.examinations && (
          <div className="nav-submenu">
            <NavLink to="/admin/examinations/notices-circulars" className="nav-sublink">
              Notices and Circulars
            </NavLink>
            <NavLink to="/admin/examinations/exam-timetables" className="nav-sublink">
              Exam Timetables
            </NavLink>
          </div>
        )}
      </div>

      {/* Media */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('media')}>
          <span>Media</span>
          <span className="nav-arrow">{expanded.media ? '▼' : '▶'}</span>
        </div>
        {expanded.media && (
          <div className="nav-submenu">
            <NavLink to="/admin/media/alumni-speak" className="nav-sublink">
              Alumni Speak
            </NavLink>
            <NavLink to="/admin/media/latest-news" className="nav-sublink">
              Latest News
            </NavLink>
            {/* <NavLink to="/admin/media/academic-news" className="nav-sublink">
              Academic News
            </NavLink>
            <NavLink to="/admin/media/admissions-news" className="nav-sublink">
              Admissions News
            </NavLink> */}
            <NavLink to="/admin/media/manet-blogs" className="nav-sublink">
              MANET Blogs
            </NavLink>
            <NavLink to="/admin/media/gallery" className="nav-sublink">
           Gallery
            </NavLink>
          </div>
        )}
      </div>

      {/* Applications Forms */}
      <div className="nav-section">
        <div className="nav-section-header" onClick={() => toggleSection('applications')}>
          <span>Applications Forms</span>
          <span className="nav-arrow">{expanded.applications ? '▼' : '▶'}</span>
        </div>
        {expanded.applications && (
          <div className="nav-submenu">
            <NavLink to="/admin/applications/contact-us" className="nav-sublink">
              Contact us
            </NavLink>
            <NavLink to="/admin/applications/enquire-now" className="nav-sublink">
              Enquire Now
            </NavLink>
            <NavLink to="/admin/applications/brochure-downloads" className="nav-sublink">
              Brochure Downloads
            </NavLink>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SidebarMenu;







